import { Injectable } from '@angular/core';
import axios from 'src/app/Service/axios';
import { GeofenceSummaryCredentials, GeofenceSummaryRange, GeofenceSummaryResponse, GeofenceSummaryStatus } from './geofence-summary-report.models';
import { numericSummaryUser } from './geofence-summary-report.utils';
@Injectable({ providedIn: 'root' })
export class GeofenceSummaryReportApiService {
  load(vehicleId: string, range: GeofenceSummaryRange, credentials: GeofenceSummaryCredentials): Promise<GeofenceSummaryResponse> {
    return this.post('Radyab_GeoFence_OriginDestination', { ...credentials, iSystemUser: numericSummaryUser(credentials.iSystemUser), strUnitID: vehicleId, ...range });
  }
  delete(ids: (number | string)[], credentials: GeofenceSummaryCredentials): Promise<GeofenceSummaryResponse> {
    return this.post('Radyab_GeoFence_OriginDestination_Delete', { ...credentials, iSystemUser: numericSummaryUser(credentials.iSystemUser), lstiGeoFence_OriginDestination: ids });
  }
  private async post(endpoint: string, payload: object): Promise<GeofenceSummaryResponse> {
    const response = await axios.post(endpoint, payload);
    const data: unknown = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
    if (Array.isArray(data)) return data;
    if (data && typeof data === 'object') return data as GeofenceSummaryStatus;
    throw new Error('پاسخ گزارش نامعتبر است');
  }
}
